// This file was auto-generated by Fern from our API Definition.
export const QueryEnvironmentsRequestOrder = {
    Ascending: "ascending",
    Descending: "descending",
};
